import {t} from "i18next";
import {dibAppApi} from "../../../dibAppApi/dibAppApi";
import {DocumentGeneratorBody} from "./DocumentGeneratorBody";
import splashClasses from "./PlaceholderSplash.module.css";

export const DOCUMENT_GENERATOR_PLACEHOLDER_ID = "i";

interface DocgenChecklistViewProps {
    documentId: string;
    collectionId?: string;
    isDraft: boolean;
    onPromptNewFilling: () => void;
}

export const DocgenChecklistView = ({
    documentId,
    collectionId,
    isDraft,
    onPromptNewFilling,
}: DocgenChecklistViewProps) => {
    const isPlaceholder = documentId === DOCUMENT_GENERATOR_PLACEHOLDER_ID;

    // Read the name for the outer header. RTK Query dedupes this against the
    // body's identical call — one network request, one cache entry.
    const {data: docData} = dibAppApi.endpoints.getDocgenDocument.useQuery(
        {resourceId: documentId, collectionId},
        {skip: isPlaceholder, refetchOnMountOrArgChange: true}
    );

    if (isPlaceholder) {
        return (
            <div className={splashClasses.splash}>
                <div className={splashClasses.stack} aria-hidden="true">
                    <div className={splashClasses.card} />
                    <div className={splashClasses.card} />
                    <div className={splashClasses.card} />
                </div>
                <p className={splashClasses.message}>
                    {t("Info.ChooseADocumentToStart")}
                </p>
            </div>
        );
    }

    return (
        <DocumentGeneratorBody
            documentId={documentId}
            collectionId={collectionId}
            isDraft={isDraft}
            onPromptNewFilling={onPromptNewFilling}
            resizableForm
            outerHeader={<h1>{docData?.topicData?.name ?? ""}</h1>}
        />
    );
};
